import { lazy, Suspense, memo } from "react";
import { useTranslation } from "react-i18next";
import HeroSection from "./HeroSection";
import AboutSection from "./AboutSection";
import MapSection from "./MapSection";
import { useStore } from "@/store/useStore";
import LoadingState from "./LoadingState";

// Lazy load heavy components
const VisionGoalsSection = lazy(() => import("./VisionGoalsSection"));
const AchievementsSection = lazy(() => import("./AchievementsSection"));
const CompanyMarquee = lazy(() => import("./CompanyMarquee"));
const PartnersSection = lazy(() => import("./PartnersSection"));

const Landing = () => {
  const { i18n } = useTranslation("common");
  const { seedData } = useStore();
  const lng = i18n.language || "en";

  if (!seedData) {
    return <LoadingState />;
  }

  return (
    <div className={lng === "ar" ? "rtl" : "ltr"}>
      <HeroSection seedData={seedData} lng={lng} />
      <AboutSection seedData={seedData} lng={lng} />
      
      <Suspense fallback={<LoadingState />}>
        <VisionGoalsSection lng={lng} />
        <AchievementsSection lng={lng} />
        <CompanyMarquee />
        <PartnersSection />
      </Suspense>
      
      <MapSection lng={lng} />
    </div>
  );
};
export const getText = (obj, key, lng) => {
  return obj?.[`${key}_${lng}`] || obj?.[`${key}_en`];
};
export default memo(Landing);